import _ from 'lodash';
import { Collection } from 'backbone';

/**
 * @desc Tipping
 * This Collection using for tipping
 */
class Tipping extends Collection {

	initialize() {
		this.prefix = 'tipping/';
	}

	setMatchesUrl() {
		this.url = 'matches';

		return this;
	}

	setAddUrl(){
		this.url = 'add';

		return this;
	}

	setAutoPickUrl(){
		this.url = 'luck_of_draw';

		return this;
	}

	get selected_tips(){
		return _.filter(
			this.toJSON(),
			({ predict_winner_squad_id }) => predict_winner_squad_id
		);
	}

	get selected_tips_post_data(){
		return _.map(
			this.selected_tips,
			({ id: match_id, predict_winner_squad_id, predict_margin }) => ({
				match_id,
				predict_winner_squad_id,
				predict_margin,
			}));
	}

	checkIsFinal(is_final = false) {
		this.prefix = is_final ? 'tipping_fin/' : 'tipping/';
		return this;
	}
}

export default Tipping;